import React from 'react';
import { Card } from 'reactstrap';
import { LowboyAssignmentStatuses } from './LowboyAssignmentStatuses';
import { Draggable } from '@hello-pangea/dnd';
import LowboyRequestCardBody from './LowboyRequestCardBody';

export default class LowboyEmployeeAssignment extends React.Component {
    canBeDeleted() {
        const { lowboyAssignmentId, lowboyAssignments } = this.props;

        const lowboyAssignment = lowboyAssignments.find(
            (la) => la.id == lowboyAssignmentId
        );

        return Boolean(
            lowboyAssignment &&
            lowboyAssignment.lowboyAssignmentStatusId <=
                LowboyAssignmentStatuses.Planned
        );
    }

    render() {
        const {
            lowboyAssignmentId,
            idx,
            lowboyResources,
            lowboyAssignments,
            equipments,
            equipmentTypes,
        } = this.props;

        if (!lowboyAssignmentId) {
            return null;
        }

        const lowboyAssignment = lowboyAssignments.find(
            (la) => la.id == lowboyAssignmentId
        );

        const lowboyResource = lowboyResources.find(
            (lr) => lowboyAssignment.lowboyResourceId == lr.id
        );

        const equipment = equipments.find(
            (eq) => lowboyAssignment.equipmentId == eq.id
        );

        const equipmentType = equipmentTypes.find(
            (et) => et.id == equipment.equipmentTypeId
        );

        const deleteEnabled = this.canBeDeleted();

        if (this.canBeDeleted()) {
            const draggableId = `da-${lowboyAssignmentId}`;

            return (
                <Draggable
                    key={draggableId}
                    draggableId={draggableId}
                    index={idx}
                >
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <Card
                                id={draggableId}
                                className="card m-2 employee-assignment-card"
                            >
                                <LowboyRequestCardBody
                                    {...this.props}
                                    showDragIndicator={deleteEnabled}
                                    lowboyResource={lowboyResource}
                                    equipmentType={equipmentType}
                                    lowboyAssignment={lowboyAssignment}
                                    equipment={equipment}
                                    removeAssignmentEnabled={
                                        deleteEnabled &&
                                        !(snapshot && snapshot.isDragging)
                                    }
                                />
                                {provided.placeholder}
                            </Card>
                        </div>
                    )}
                </Draggable>
            );
        }

        return (
            <Card key={`show-card-${lowboyAssignmentId}`}>
                <LowboyRequestCardBody
                    {...this.props}
                    lowboyResource={lowboyResource}
                    equipmentType={equipmentType}
                    lowboyAssignment={lowboyAssignment}
                    equipment={equipment}
                />
            </Card>
        );
    }
}
